// QA check with HW

import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {LicenseDataCsvImportRequest, LicenseDataRequest, LicenseDataResponse,} from '../../../../contracts/v0/contracting/license-data.contracts';
import {ApiV0Contracting} from '../api.v0.contracting';

export class ApiV0LicenseData {
    segment: string;

    constructor(v0: ApiV0Contracting, private rest: RestApiService) {
        this.segment = v0.segment + '/licenseData';
    }

    list(): Observable<BaseCollectionModel<LicenseDataResponse>> {
        return this.rest.get<BaseCollectionModel<LicenseDataResponse>>(`${this.segment}/list`, LicenseDataResponse)
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<LicenseDataResponse>> {
        return this.rest.post<SearchModel, BaseCollectionModel<LicenseDataResponse>>(`${this.segment}/search`, LicenseDataResponse, searchModel)
    }

    detail(guid: string): Observable<LicenseDataResponse> {
        return this.rest.get(`${this.segment}/details/${guid}`, LicenseDataResponse)
    }

    create(createRequest: LicenseDataRequest) {
        return this.rest.post<LicenseDataRequest, LicenseDataResponse>(`${this.segment}/create`, LicenseDataResponse, createRequest)
    }

    update(updateRequest: LicenseDataRequest) {
        return this.rest.patch<LicenseDataRequest, LicenseDataResponse>(`${this.segment}/update`, LicenseDataResponse, updateRequest)
    }

    delete(guid: string) {
        return this.rest.delete<void>(`${this.segment}/delete/${guid}`)
    }

    importCsvData(data: LicenseDataCsvImportRequest): Observable<BaseCollectionModel<LicenseDataResponse>> {
        return this.rest.post<LicenseDataCsvImportRequest, BaseCollectionModel<LicenseDataResponse>>(
            `${this.segment}/import/csv`,
            LicenseDataResponse,
            data
        )
    }

    importExcelData(data: LicenseDataCsvImportRequest): Observable<BaseCollectionModel<LicenseDataResponse>> {
        return this.rest.post<LicenseDataCsvImportRequest, BaseCollectionModel<LicenseDataResponse>>(
            `${this.segment}/import/excel`,
            LicenseDataResponse,
            data
        )
    }
}

